import React from 'react';
import PartnerSidebar from './PartnerSidebar';

const PartnerLayout = ({ access, children }) => {
  return (
    <div className="partner-layout">
      <PartnerSidebar access={access} />
      <section className="partner-layout-content">{children}</section>
    </div>
  );
};

export default PartnerLayout;
